import Store from './Store';
import AppDispatcher from '../dispatcher/Dispatcher';
import Location from '../panther/core/Location';

class UrlStateStore extends Store {

    constructor(props){
        super(props);
        this._state = this.getDefaultState();
    }

    changeState(view) {
        this.setState({
           view: view
        });
        this.emit("VIEW_CHANGE", view);
    }

    getDefaultState(){
        let hash = window.location.hash.slice(1);
        if (hash === "microsite-map"){
            return {
                view: 'map'
            }
        } else {
            return {
                view: 'page'
            }
        }
    }

    getState() {
        return this._state;
    }

    setState(options){
        this._state.view = options.view;
        if (this._state.view === "map"){
            this.replaceUrl("#microsite-map");
        } else if (options.view) {
            document.querySelector("#" + options.view).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            this.replaceUrl("#" + options.view);
        }
    }

    replaceUrl(hash) {
        console.log("UrlStateStore#replaceUrl");
        let path = window.location.pathname;
        let url = path + hash;
        Location.replace(url, null);
    }

}

let storeInstance = new UrlStateStore();

storeInstance.dispatchToken = AppDispatcher.register(action => {
    switch(action.actionType) {
        case "VIEW_CHANGE":
            storeInstance.changeState(action.view);
            break;
        default:
            return;
    }

});

export default storeInstance;

